import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CryptoJS from "crypto-js";

const initialChangePasswordObj = {
  oPassword: "",
  nPassword: "",
  cPassword: "",
};

const initialShowError = {
  oPassword: false,
  nPassword: false,
  cPassword: false,
};

const ChangeAdminPassword = () => {
  const [changePassword, setChangePassword] = useState(
    initialChangePasswordObj
  );
  const [showError, setShowError] = useState(initialShowError);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const passwordChangeHandler = (e) => {
    setChangePassword((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  useEffect(() => {
    const admin = localStorage.getItem("user");
    if (admin) {
      const bytes = CryptoJS.AES.decrypt(admin, "thisistest");
      const id = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      setChangePassword((prev) => ({ ...prev, id: id.id }));
    }
  }, []);

  const formSubmitHandler = async () => {
    const { oPassword, nPassword, cPassword } = changePassword;

    if (nPassword !== cPassword) {
      setShowError((prev) => ({ ...prev, nPassword: true, cPassword: true }));
      return;
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}change-password`, {
      method: "POST",
      body: JSON.stringify(changePassword),
      headers: {
        "Content-Type": "application/json",
      },
    });

    console.log(response);
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4">
            <h4 className="fs-20 font-w600 mb-0 me-auto">Change Password</h4>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header">
                  <h5 className="card-title">Change Password</h5>
                </div>
                <form onSubmit={handleSubmit(formSubmitHandler)}>
                  <div className="card-body">
                    <div className="basic-form">
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Old Password
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="password"
                            className="form-control"
                            {...register("oPassword", { required: true })}
                            placeholder="Password"
                            defaultValue={changePassword.oPassword}
                            onChange={passwordChangeHandler}
                          />
                          {showError.oPassword && <p>This field is required</p>}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          New Password
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="password"
                            className="form-control"
                            {...register("nPassword", { required: true })}
                            placeholder="New Password"
                            defaultValue={changePassword.nPassword}
                            onChange={passwordChangeHandler}
                          />
                          {showError.nPassword && <p>This field is required</p>}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="col-sm-3 col-form-label">
                          Confirm Password
                        </label>
                        <div className="col-sm-9">
                          <input
                            type="password"
                            className="form-control"
                            {...register("cPassword", { required: true })}
                            placeholder="Confirm Password"
                            defaultValue={changePassword.cPassword}
                            onChange={passwordChangeHandler}
                          />
                          {showError.cPassword && <p>This field is required</p>}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-sm-flex justify-content-between align-items-center">
                    <div className="card-footer-link mb-4 mb-sm-0">
                      <p className="card-text text-dark d-inline">
                        Last updated 3 mins ago
                      </p>
                    </div>
                    <button className="btn btn-primary" type="submit">
                      Change Password
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChangeAdminPassword;
